import React, { useLayoutEffect, useRef, useState } from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import RegionCityList from '../regionCityList';

const CustomToggle = React.forwardRef(({ children, onClick, empty }, ref) => (
  <CityToggle
    forwardedRef={ref}
    children={children}
    onClick={onClick}
    empty={empty}
  />
));

const CityToggle = ({ forwardedRef, children, onClick, empty }) => {
  const labelRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useLayoutEffect(() => {
    const updateOverflow = () => {
      const label = labelRef.current;
      setIsOverflowing(Boolean(label && label.scrollWidth > label.clientWidth));
    };

    updateOverflow();
    window.addEventListener('resize', updateOverflow);
    return () => window.removeEventListener('resize', updateOverflow);
  }, [children]);

  return (
    <Button
      ref={forwardedRef}
      className={`dropdown-btn${empty ? ' empty' : ''}`}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      <i className="fas fa-map-marker-alt" />
      <span
        ref={labelRef}
        className={isOverflowing ? 'dropdown-btn__label--overflowing' : ''}
      >
        {children}
      </span>
      <i className="fas fas--arrow fa-chevron-down" />
    </Button>
  );
};

const CityDropdown = ({ onChange, onRegionChange, currentCity, currentRegion, cities, regions }) => {
  const buttonRef = useRef();
  const [show, setShow] = useState(false);

  const label = currentCity
    ? currentCity.name
    : currentRegion
    ? currentRegion.name
    : 'Оберіть місто';

  const isEmpty = !currentCity && !currentRegion;

  const handleSelectCity = (city) => {
    if (onChange) onChange(city);
    setShow(false);
    if (buttonRef.current) buttonRef.current.blur();
  };

  const handleSelectRegion = (region) => {
    if (onRegionChange) onRegionChange(region);
    setShow(false);
    if (buttonRef.current) buttonRef.current.blur();
  };

  return (
    <Dropdown className="city-dropdown" show={show} onToggle={(isOpen) => setShow(isOpen)}>
      <Dropdown.Toggle ref={buttonRef} as={CustomToggle} empty={isEmpty}>
        {label}
      </Dropdown.Toggle>

      <Dropdown.Menu style={{ minWidth: '15rem' }}>
          <RegionCityList
            regions={regions || []}
            cities={cities || []}
            currentRegion={currentRegion}
            currentCity={currentCity}
            onSelectRegion={handleSelectRegion}
            onSelectCity={handleSelectCity}
          />
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CityDropdown;
